export default {
  notReleased: "Ikke publisert",
  consent: {
    continue: 'Fortsett',
    back: 'tilbake'
  },
  menu: {
    tooltip: "Handlinger",
    editor: "Åpne i låteditor",
    downloadArtwork: "Last ned albumkunst",
    unpublish: "Avpubliser",
    delete: "Slett",
  },
  warnings: {
    unpublish: "Dette vil permanent slette publiseringsdato og gjemme låten fra offentlige systemer, er du helt sikker?",
    delete: "Dette vil permanent slette låta fra systemet, er du helt sikker?",
  }
}



// WEBPACK FOOTER //
// ./src/locales/no/component/module/artist/misc/TrackStrip.js